// angular
import {
    Component,
    ElementRef,
    EventEmitter,
    Input,
    OnInit,
    Output,
    ViewChild,
    Inject,
    HostListener,
    OnChanges,
    SimpleChanges,
    OnDestroy
} from '@angular/core';

import { ActivatedRoute, Router } from '@angular/router';
// services
import { PatientsService } from '../../patients/patients.service';
import { AppService } from '../../app.service';
import { AuthService } from '../../core/auth.service';
import { BaseComponent } from '../../shared/base.component';
import { BaseService } from '../../shared/base.service';
// others
import * as svgPanZoom from 'svg-pan-zoom/src/svg-pan-zoom';
import { DialogComponent } from '../../dialog/dialog.component';
import { PatientService } from '../patient.service';
import * as Hammer from 'hammerjs';
import { HELP_DI_MAP, HELP_SE_MAP } from '../../shared/constants/help-buttons';
import { PopoverComponent } from '../../shared/popover/popover.component';
import { TranslateService } from '@ngx-translate/core';
import { Subscription, Subject } from 'rxjs';
import { BsDropdownDirective } from "ngx-bootstrap/dropdown";
import * as d3 from 'd3';
import { QuestionnairesService } from '../questionnaires/questionnaires.service';
import { DOCUMENT } from '@angular/common';
import { ProposalInterface } from '../../models/proposal.interface';
import { InteractiveMapComponent } from './interactive-map/interactive-map.component';
import { ProposalDiagnogisComponent } from '../proposal-diagnosis/proposal-diagnosis.component';
import { ComparisonMapComponent } from './comparison-map/comparison-map.component';
import { UsersService } from '../../users/users.service';
import { PatientQuestionnairesComponent } from '../patient-questionnaires/patient-questionnaires.component';
import * as _ from 'lodash';

declare const window;

@Component({
    selector: 'app-symptom-map-component',
    templateUrl: 'symptom-map.component.html',
    styleUrls: ['symptom-map.component.scss'],
    providers: [
        PatientsService,
        BsDropdownDirective,
        {provide: 'HELP_DI_MAP', useValue: HELP_DI_MAP},
        {provide: 'HELP_SE_MAP', useValue: HELP_SE_MAP},
        UsersService
    ],
})

export class SymptomMapComponent extends BaseComponent implements OnInit, OnDestroy {

    @Input() patientId: number;

    @Input() patientSurname: string;

    @Input() patientName: string;

    @Input() symptomMapId: string;

    @Input() currentDates = [];

    @Input() questionnairesComponent: PatientQuestionnairesComponent;
    role: any;

    @Input() isViewOnly: any;

    @Input() selectedSymptomMap: string;

    @Input() completedDates = [];

    @Input() getDiagnosisData: boolean;

    @Output() scrollToMap = new EventEmitter<any>();
    @Output() enableComparison = new EventEmitter<any>();
    @Output() changePatientTab = new EventEmitter<any>();

    selectedComparisonId = 0;
    selectedComparisonDate: string;
    selectedCurrentId = 0;
    selectedCurrentDate: string = '';
    showGraphic = false;
    graphicData: any;
    SVG: any;

    initialSymptomMap = false;

    zoomLevel = 2;
    firstZoomScale = 1.2;
    zoomScales = [this.firstZoomScale, 1.8, 4];

    svgPanZoomInstance: any;

    isFullScreen = false;

    allDomainsAreShown = true;

    showLegends = false;

    isComparisonViewMode = false;
    editMode = false;
    viewMode = true;

    token: string;

    responseMessage: string;

    panValues: Object;

    minimizedHeight = 663;

    @ViewChild('symptomMapSvg', {static: false}) symptomMapSvg: ElementRef;

    @ViewChild('replyDate', {static: false}) replyDate: ElementRef;

    @ViewChild(DialogComponent, {static: false}) dialog: DialogComponent;

    @ViewChild(PopoverComponent, {static: false}) popover: PopoverComponent;

    // access control
    sendQuestionnaire: boolean;

    @Output() disableDiagnoses = new EventEmitter<any>();
    @Output() enableEditMode = new EventEmitter<any>();
    @Input() collapseDiagnoses: boolean;
    @ViewChild('comparesDateDropdown', {static: false}) comparesDateDropdown: BsDropdownDirective;

    showGestureHint: boolean;
    styles = {'width': '18px'};

    isCompared: boolean;
    isScrolling: boolean = false;
    private subscription: Subscription;
    comparisonData: {
        new_appearance: any,
        negative_change: any,
        no_change: any,
        positive_change: any
    };
    selectedComparisonType: string;
    hoveredIncreased = false;
    canEdit = false;
    latestQuestionnaire: any;
    selectedCurrentQuestionnaire : any;
    mapStyles = {
        left: 24
    };

    menuBtn = {
        'top': '0',
        'right': '0'
    };
    showDropdown = false;
    dropdownPosition = {
        'top': '0',
        'right': '0',
        'position': 'fixed'
    };
    menuDirection = 'toggle-up';
    exportRoute = {
        current: ''
    };
    openInteractive = false;
    openProposalDiagnosis = false;
    triggerOpenProposalDiagnosis = false;
    activeItemId = null;
    activeItem = {
        type: 'symptom',
        rating: null,
        systemId: null,
        domainId: null,
        element: <HTMLElement> null,
        data: null,
    };
    interactivePanel: HTMLElement;
    interactiveSymptomMap: any;
    updatingInteractiveMap = false;
    mapUpdated = false;
    domainNode: any;
    symptomNode: any;
    symptomIcon: any;
    RATING_CLASS = {
        mild: 'rating-low',
        moderate: 'rating-middle',
        severe: 'rating-high',
        none: 'unselected-symptom',
        selected: 'selected-symptom',
        // anamnestic:
    };
    loadMapCompleted = new Subject();
    loadMapCompletedSub: Subscription;
    dragging = false;
    focusingOnMap = false;
    expertDatas = [];
    showExpertsElement = false;
    @ViewChild('interactiveMapComponent', {static: false}) interactiveMapComponent: InteractiveMapComponent;
    @ViewChild('diagnosisComponent', {static: false}) diagnosisComponent: ProposalDiagnogisComponent;
    @ViewChild('comparisonMap', {static: false}) comparisonMap: ComparisonMapComponent;
    lang: string = this.translate.currentLang;
    isMapVisible = true;
    QUESTIONNAIRE_IN_PROGRESS = 'In progress';

    diagnosesSub: Subscription;

    // Comparision
    openComparison : boolean = false;
    HELP_DI_MAP = HELP_DI_MAP;
    HELP_SE_MAP = HELP_SE_MAP;

    constructor(public elementRef: ElementRef,
                public patientsService: PatientsService,
                public patientService: PatientService,
                public appService: AppService,
                public authService: AuthService,
                public router: Router,
                public baseService: BaseService,
                @Inject(DOCUMENT) public document: Document,
                @Inject('reviewProposalStatisticKey') public reviewProposalStatisticKey,
                public translate: TranslateService,
                public route: ActivatedRoute,
                public questionnairesService: QuestionnairesService,
                public usersService: UsersService,
    ) {
        super(authService, router, baseService, appService);

        this.subscription = this.translate.onLangChange.subscribe(value => {
            this.loadSymptomMap(true);
        })
    }

    ngOnInit() {
        this.role = JSON.parse(localStorage.getItem('user'))['role_id'];

        this.sendQuestionnaire = this.authService.isAuthorised('patient.send-questionnaire');

        // Detect Tablet and change scale size
        if (window.innerWidth <= 1024) {
            this.zoomScales[0] = 1.1;
        }
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
        this.patientService.latestMapId = 0;
    }

    openCreateQuestionnaire() {
        this.questionnairesComponent.openFormModal({
            action: 'add',
            url: '',
            title: 'Open Questionnaire',
            questionnaireType: 'se_di',
            answerMethod: 'local'
        });
    }

    handleSymptomMap(selector: string): any {
        const symptomMap = document.querySelector(selector);

        if (!symptomMap) {
            return;
        }

        const beforePan = function (oldPan, newPan) {
            const sizes = this.getSizes();
            const offsetX = sizes.width / 1.1;
            const offsetY = sizes.height / 1.1;
            const leftLimit = -((sizes.viewBox.x + sizes.viewBox.width) * sizes.realZoom) + offsetX - 200;
            const rightLimit = sizes.width - (sizes.viewBox.x * sizes.realZoom) - offsetX + 200;
            const topLimit = -((sizes.viewBox.y + sizes.viewBox.height) * sizes.realZoom) + offsetY;
            const bottomLimit = sizes.height - (sizes.viewBox.y * sizes.realZoom) - offsetY;

            const customPan = {};
            customPan['x'] = Math.max(leftLimit, Math.min(rightLimit, newPan.x));
            customPan['y'] = Math.max(topLimit, Math.min(bottomLimit, newPan.y));

            return customPan;
        };

        const self = this;
        const svgPanZoomInstance = svgPanZoom(symptomMap, {
            zoomEnabled: true,
            fit: true,
            center: true,
            minZoom: self.zoomScales[0],
            maxZoom: self.zoomScales[2],
            mouseWheelZoomEnabled: false,
            dblClickZoomEnabled: false,
            preventMouseEventsDefault: false,
            beforePan: beforePan,
            // store the position of the symptom map to keep the same position for the same map type
            onPan: function (newPan) {
                self.panValues = newPan;
            },
            customEventsHandler: {
                // Halt all touch events
                haltEventListeners: []

                // Init custom events handler
                , init: function (options) {
                    // Init Hammer
                    this.hammer = Hammer(options.svgElement, {dragLockToAxis: true, touchAction: 'pan-y'});

                    // prevent page scrolling with swipe/drag events
                    this.hammer.on('swipe drag', function (event) {
                        if (event.gesture && (event.gesture.direction === Hammer.DIRECTION_UP
                            || event.gesture.direction === Hammer.DIRECTION_DOWN)) {
                            event.gesture.preventDefault();
                        }
                    });

                    // handle pinch events
                    this.hammer.get('pinch').set({enable: true});

                    let isPinchIn = false;

                    this.hammer.on('pinchin', function (ev) {
                        isPinchIn = true;
                    });

                    this.hammer.on('pinchout', function (ev) {
                        isPinchIn = false;
                    });

                    function handlePinchZoom() {
                        if (isPinchIn) {
                            self.zoomOut(self.svgPanZoomInstance);
                            isPinchIn = false;
                        } else {
                            self.zoomIn(self.svgPanZoomInstance);
                            isPinchIn = true;
                        }
                    }

                    this.hammer.on('pinchend', handlePinchZoom);
                    this.hammer.on('pinchcancel', handlePinchZoom);
                }

                // Destroy custom events handler
                , destroy: function () {
                    this.hammer.destroy();
                }
            }
        });
        symptomMap.setAttribute('class', 'level1');

        this.zoom(svgPanZoomInstance);

        // when switching to the comparison mode / to another date, keep the same position of the map
        // & add the zoom level css class to ensure the map is displayed correctly based on the current zoom level
        if (this.zoomLevel !== 1) {
            if (this.panValues) {
                svgPanZoomInstance.pan(this.panValues);
            }

            document.querySelector('#symptom-map-svg-content-' + this.symptomMapId + ' svg')
                .setAttribute('class', 'level' + this.zoomLevel);
        }

        return svgPanZoomInstance;
    }

    interactiveMap(event ?: any) {
        if(this.openProposalDiagnosis || this.dragging){
            // Disable interactive when access Proposal Diagnosis
            return false;
        }
        if (!event) {
            this.openInteractive = false;
            this.activeItem.systemId = null;
            this.activeItemId = 0;
            if (this.activeItem.element) {
                this.activeItem.element.parentElement.classList.remove('focus');
                if (this.symptomNode && this.symptomNode.querySelector('rect')) {
                    this.symptomNode.querySelector('rect').remove();
                }
            }
            if (this.editMode && this.isFullScreen) {
                return this.toggleFullScreen(false);
            }
            return;
        }

        const SVGElementsAllow = [
            // Symptom element
            'circle',
            // Symmptom Name & Domain name
            'text',
            'tspan',
            'polygon',
            // Domain Area
            // 'path',
        ];
        let systemId = event.target.getAttribute('attr-systemid');
        const domainId = event.target.getAttribute('attr-domainid');
        const attrNode = event.target.getAttribute('attr-node');
        if (!systemId && event.target.parentNode && event.target.parentNode.getAttribute('attr-systemid')) {
            systemId = event.target.parentNode.getAttribute('attr-systemid');
        }
        if ((!systemId && !domainId) || SVGElementsAllow.indexOf(event.target.nodeName) < 0) {
            return;
        }
        /**
         *  Case 1 : Click on Domain Name
         *  Only allow on Edit mode
         */
        if (domainId && attrNode === 'domain-name') {
            if(this.viewMode){
                return false;
            }
            this.domainNode = event.target.parentElement;
            this.activeItem.element = this.domainNode;
            this.activeItem.type = 'domain';
            this.activeItem.domainId = domainId;
            this.activeItemId = domainId;
            return;
            // Handle move map to center in the view mode
            // return this.editMode ? this.toggleFullScreen(true) : false;
        }
        /**
         *  Case 2: Click on Symptom level
         */
        this.activeItem.element = event.target.nodeName !== 'tspan' ? event.target : event.target.parentNode;
        this.activeItem.systemId = systemId;
        this.activeItemId = systemId;
        this.activeItem.rating = event.target.getAttribute('attr-rating');
        this.symptomIcon = this.activeItem.element;
        this.symptomNode = this.symptomIcon.parentElement;
        this.activeItem.type = (this.symptomNode && this.symptomNode.getElementsByTagName('circle').length <= 1) ? 'normal' : 'comparison';
        this.domainNode = this.symptomNode.parentElement;
        this.openInteractive = true;

        // Add highlight for focus symptom
        this.setFocusState(this.symptomNode);
        this.domainNode.appendChild(this.symptomNode);

        // Handle move map to center in the view mode
        //return this.editMode ? this.toggleFullScreen(true) : this.alignMapFocusMode(event);
    }

    alignMapFocusMode(e) {
        this.interactivePanel = document.querySelector('#symptom-map-tab-' + this.symptomMapId + ' #interactive-map') as HTMLElement;

        if (e.clientX > window.innerWidth/2 ) {
            this.mapStyles.left = 0 - this.interactivePanel.offsetWidth;
        }
        return true;
    }

    updateInteractiveMap(response) {
        if (response) {
            // Set sSymptom node
            if (response.icon) {
                this.symptomNode = this.interactiveSymptomMap.querySelector('[id="' + response.icon.system_id + '"]');
            }
            const newIcon = response.icon && response.icon.node ? response.icon.node : null;
            const newRating = response.icon && response.icon['rating-class'] ? response.icon['rating-class'] : this.RATING_CLASS.none;
            // Update Domain Class
            this.domainNode = response.domainId ? this.interactiveSymptomMap.querySelector('#' + response.domainId) : this.domainNode;
            if (response.domainCls && response.domainCls !== '') {
                this.domainNode.setAttribute('class', response.domainCls);
                this.domainNode.querySelector('#dialog_' + this.domainNode.getAttribute('id')).setAttribute('class', 'domain-name ' + response.domainCls);

                const subDomainsNode = this.domainNode.getElementsByClassName('subdomain');
                if (response.subdomainCls) {
                    for (let i = 0; i < subDomainsNode.length; i++) {
                        subDomainsNode[i].setAttribute('class', 'subdomain ' + response.subdomainCls);
                    }
                    const domainName = this.domainNode.querySelector('#dialog_' + this.domainNode.getAttribute('id') + '_name');
                    if (domainName) {
                        domainName.setAttribute('class', 'domain-name');
                    }
                }
                if(response.activeDomain){
                    this.domainNode.classList.add('domain-active');
                }
            }
            // Update Domain History
            if (response.syndrome) {
                let historySVG = response.syndrome.syndrome_history_svg;
                const syndromeId = response.syndrome.syndrome_history_id;
                const syndromeCls = response.syndrome.syndrome_history_class;
                const historyNode = this.domainNode.querySelector('#' + syndromeId);
                const circleNode = historyNode.querySelector('circle').outerHTML;
                historySVG = circleNode + historySVG;
                historyNode.innerHTML = historySVG;
                historyNode.setAttribute('class', syndromeCls);
            }

            if ((newRating !== this.RATING_CLASS.none && response.isAnamnestic) || !response.icon || !response.icon.node) {
                return true;
            }
            this.symptomNode.innerHTML = newIcon;

            this.activeItem.element = this.symptomNode.lastChild;
            // Update rating class
            if (newIcon) {
                const classList = this.symptomNode.classList;
                for (let cls in this.RATING_CLASS) {
                    if (classList.contains(this.RATING_CLASS[cls])) {
                        this.symptomNode.classList.remove(this.RATING_CLASS[cls]);
                        this.symptomNode.classList.add(newRating);
                        this.activeItem.rating = newRating;

                        if (newRating !== this.RATING_CLASS.none) {
                            this.symptomNode.classList.add(this.RATING_CLASS.selected);
                        }
                    }
                }
                //Re-Draw highligt Rect when selected a symptom
                this.setFocusState(response.activeSymptom);
            }

            // Set Map has been Updated
            this.mapUpdated = true;
            this.loadLatestSymptomMap(this.selectedCurrentId);
        }
    }

    setFocusState(symptom = null) {
        // Remove current highlight on task list
        if (this.interactiveSymptomMap.querySelector('.symptom-icon > rect')) {
            const highlightedElements = this.interactiveSymptomMap.querySelectorAll('.symptom-icon rect');
            if (highlightedElements) {
                highlightedElements.forEach(rect => {
                    rect.remove();
                });
            }
        }
        if(this.interactiveSymptomMap.querySelector('.symptom-icon.focus')){
            const focusElements = this.interactiveSymptomMap.querySelectorAll('.symptom-icon.focus');
            if (focusElements) {
                focusElements.forEach(element => {
                    element.classList.remove('focus');
                });
            }

        }
        if(!symptom){
            return false;
        }
        this.symptomNode = symptom.system_id ? this.interactiveSymptomMap.querySelector('[id="' + symptom.system_id + '"]') : this.symptomNode;
        if (!this.symptomNode) {
            return false;
        }
        this.symptomNode.classList.add('focus');
        const rectNode = document.createElementNS('http://www.w3.org/2000/svg', 'rect');
        // Wait for loading font weight
        let symptomNode = this.symptomNode;
        setTimeout(function () {
            const svgDa = symptomNode.getBBox();
            rectNode.setAttribute('x', (svgDa.x - 12.5) + 'px');
            rectNode.setAttribute('y', (svgDa.y - 14) + 'px');
            rectNode.setAttribute('width', (svgDa.width + 28) + 'px');
            const rectHeight = (svgDa.height + 26) < 45 ? 45 : (svgDa.height + 26);
            rectNode.setAttribute('height', rectHeight + 'px');
            rectNode.setAttribute('rx', '10');
            rectNode.setAttribute('class', 'highlight-border');
            rectNode.setAttribute('transform', symptomNode.querySelector('text').getAttribute('transform'));
            symptomNode.prepend(rectNode);
            const domainNode = symptomNode.parentElement;
            domainNode.appendChild(symptomNode);
        }, 100);
    }

    setActiveDomain(domain) {
        // remove Highlighted Symptom
        this.setFocusState(false);
        if (this.interactiveSymptomMap.querySelector('.map-overlay')) {
            this.interactiveSymptomMap.querySelector('.map-overlay').remove();
        }
        if (this.interactiveSymptomMap.querySelector('.domain-active')) {
            this.interactiveSymptomMap.querySelector('.domain-active').classList.remove('domain-active');
        }
        const rootNode = this.interactiveSymptomMap.querySelector('#rootNode');
        rootNode.setAttribute('class', '');
        if(!domain){
            this.clearInteractiveData();
            return this.resetOverviewMap();
        }
        if (domain && domain.domain_map_id) {
            this.zoomLevel = 2;
            this.interactiveSymptomMap.querySelector('#symptom-map').setAttribute('class', 'level' + this.zoomLevel);
            //REM: Apparently the values need some time to adjust after reset() is called, yet is seems to have no callback.
            this.zoomToPoint(domain.domain_map_id);
            const domainNode = this.interactiveSymptomMap.querySelector('#' + domain.domain_map_id);
            domainNode.classList.add('domain-active');
            rootNode.appendChild(domainNode);
            rootNode.classList.add('have-domain-activate');
        }
    }

    zoomToPoint(elementId){
        const _self = this;
        _self.svgPanZoomInstance.reset();
        const currentHeight = _self.symptomMapSvg.nativeElement.offsetHeight;
        const zoomTo = (_self.zoomLevel * (_self.minimizedHeight / currentHeight) + 0.5);
        _self.svgPanZoomInstance.zoom(zoomTo);
        window.setTimeout(function () {
            const bb = _self.interactiveSymptomMap.querySelector('[id="' + elementId + '"]').getBBox();
            const vbb = _self.svgPanZoomInstance.getSizes().viewBox;
            const posX = vbb.width / 2 - bb.x - bb.width / 2;
            const posY = vbb.height / 2 - bb.y - bb.height / 2;
            const rz = _self.svgPanZoomInstance.getSizes().realZoom;
            _self.svgPanZoomInstance.panBy(
                {
                    x: (posX * rz),
                    y: (posY * rz) - 100
                }
            );
        }, 50);
    }
    clearInteractiveData(){
        this.activeItemId = 0;
        this.activeItem = {
            type: 'symptom',
            rating: null,
            systemId: null,
            domainId: null,
            element: <HTMLElement> null,
            data: null,
        };
    }

    closeInteractive(event) {
        if (event.hasOwnProperty('interactive') && event.interactive) {
            if (this.activeItem.element) {
                this.activeItem.systemId = null;
                this.activeItemId = 0;
                this.activeItem.element.parentElement.classList.remove('focus');
                if (this.activeItem.element.parentElement.querySelector('rect')) {
                    this.activeItem.element.parentElement.querySelector('rect').remove();
                }
            }
            return this.setFocusState(false);
        }
        return this.interactiveMap(false);
    }

    closeProposalDiagnosis(event) {
        if (event.hasOwnProperty('proposal') && event.proposal) {
            // Will handle more action when close with params
        }

        this.unhighlightProposalDiagnosis();
        this.openProposalDiagnosis = false;
    }

    setMapDisable(disable = true) {
        this.updatingInteractiveMap = disable;
    }

    onMapTouchStart(event) {
        // Disable scroll and move Map only on Tablet and View Mode in Level 1
        if (this.zoomLevel === 1 && this.viewMode) {
            this.svgPanZoomInstance.disablePan();
        } else {
            this.svgPanZoomInstance.enablePan();
        }
    }

    onMapTouchMove(event) {
        if (event.touches.length === 2) {
            event.preventDefault();
        }
    }

    adjustFirstZoomScale() {
        if (!('ontouchstart' in document.documentElement)) {
            if (this.zoomLevel === 1) {
                this.svgPanZoomInstance.zoom(this.zoomScales[0]);
            }
        } else {
            if (this.zoomLevel === 1) {
                this.svgPanZoomInstance.fit();
            }
        }
    }

    toggleFullScreen(fullscreen = false) {
        this.isFullScreen = fullscreen || !this.isFullScreen;
        this.editMode = !fullscreen ? false : this.editMode;
        this.viewMode = !this.editMode;
        if(fullscreen){
            this.document.body.classList.add("disable-scroll");
        } else{
            this.document.body.classList.remove("disable-scroll");
        }

        // waiting to set the new size of the map's wrapper
        setTimeout(() => {
            this.svgPanZoomInstance.resize();

            if (!this.isFullScreen) {
                this.zoomLevel = 1;
                document.querySelector('#symptom-map-svg-content-' + this.symptomMapId + ' svg')
                    .setAttribute('class', 'level' + this.zoomLevel);
            }

            if (this.zoomLevel === 1) {
                this.adjustFirstZoomScale();
                this.svgPanZoomInstance.center();
            }

        }, 200);
    }

    toggleUnselectedDomains() {
        this.allDomainsAreShown = !this.allDomainsAreShown;
    }

    onSelect() {
        // need this timeout to ensure this function is called after selectedCurrentId is set properly
        setTimeout(() => {
            this.selectedCurrentDate = '';
            for (let currentDate of this.currentDates) {
                if (currentDate.id === this.selectedCurrentId) {
                    this.selectedCurrentDate = currentDate.date;
                    break;
                }
            }

            if (this.questionnairesComponent) {
                this.selectedComparisonId = 0;
                if (this.questionnairesComponent.items.length == 0) {
                    this.selectedCurrentId = 0;
                }
                this.questionnairesComponent.setSelectedId(this.selectedCurrentId);
            }
            this.loadSymptomMap();
            this.showGraphic = false;
            this.getHasComparedMap(this.selectedCurrentId);

            if (this.selectedCurrentDate === '') {
                this.selectedCurrentDate = this.QUESTIONNAIRE_IN_PROGRESS;
            }
        }, 100);
    }

    get comparisonDates() {
        return this.currentDates.filter((item) => {
            return item.id < this.selectedCurrentId;
        });
    }

    getHasComparedMap(id) {
        let items = this.questionnairesComponent.items;
        items.forEach(item => {
            if (this.symptomMapId == 'SE' && item['id'] == id) {
                this.isCompared = item['is_compared'];
            } else if (this.symptomMapId == 'DI' && item['di_questionnaire'] && item['di_questionnaire'].id == id) {
                this.isCompared = item['di_questionnaire'].is_compared;
            }
        });
    }

    enableComparisonMode(data) {
        this.isComparisonViewMode = data;
        this.selectedComparisonType = this.selectedComparisonType || 'none';
        this.selectedComparisonId = data ? this.comparisonDates[0]['id'] : 0;
        this.loadSymptomMap();
        return this.enableComparison.emit(this.isComparisonViewMode);
    }

    updateComparedMap(id) {
        let items = this.questionnairesComponent.items;
        this.isCompared = true;
        this.showLegends = true;
        items.forEach(item => {
            if (this.symptomMapId == 'SE') {
                item['is_compared'] = true;
            } else if (this.symptomMapId == 'DI' && item['di_questionnaire']) {
                item['di_questionnaire'].is_compared = true;
            }
        });
    }

    loadSymptomMap(onLanguageChange = false) {
        if (!this.selectedCurrentId) {
            this.svgPanZoomInstance = null;
            return;
        }

        this.isLoading = true;
        // Set Map updated to False
        this.mapUpdated = false;
        this.canEdit = false;
        this.patientsService.getComparisonSVG(this.selectedCurrentId, this.selectedComparisonId, this.translate.currentLang, this.getDiagnosisData ? 1 : 0)
            .subscribe((response: any) => {
                if(this.getDiagnosisData){
                    this.updateSelectedDiagnoses(response);
                }

                if (response.total) {
                    this.comparisonData = response.total;
                }
                if (response.proposal && !onLanguageChange) {
                    this.patientService.proposalData = response.proposal;
                    this.appService.publish('patient', { selectedDiagnosesAreUpdated: true, items: this.patientService.proposalData });
                }
                if (response.data) {
                    this.initialSymptomMap = true;
                    this.symptomMapSvg.nativeElement.innerHTML = response.data;
                    this.svgPanZoomInstance = this.handleSymptomMap('#symptom-map-svg-content-' + this.symptomMapId + ' svg');

                    this.scrollToMap.emit();

                    if (this.isMapVisible) {
                        this.adjustFirstZoomScale();
                    }

                    // add the class for desktops only
                    if (!this.isTouchDevice()) {
                        const mapMenuEl = document.getElementsByClassName('symptom-map');
                        for (let i = 0; i < mapMenuEl.length; i++) {
                            mapMenuEl[i].classList.add('desktops');
                        }
                    }

                    // prevent page zooming on ios
                    document.addEventListener('gesturestart', (e) => e.preventDefault());

                    // clone svg map
                    // const svgCopy = document.querySelector('#symptom-map-svg-content-' + this.symptomMapId + ' svg');
                    // svgCopy.setAttribute('class', 'level2');
                    document.getElementById('map-content-' + this.symptomMapId).innerHTML = document.getElementById('symptom-map-svg-content-' + this.symptomMapId).innerHTML;
                } else {
                    this.svgPanZoomInstance = null;
                    document.getElementById('map-content-' + this.symptomMapId).innerHTML = '';
                }

                this.loadLatestSymptomMap(this.selectedCurrentId);
                this.latestQuestionnaire = this.questionnairesComponent.items[0];
                this.questionnairesComponent.items.forEach(item => {
                    if ((this.symptomMapId === 'SE' && item['id'] === this.selectedCurrentId) || (this.symptomMapId === 'DI' && item['di_questionnaire']['id'] === this.selectedCurrentId)) {
                       this.selectedCurrentQuestionnaire = item;
                    }
                });
                if ((this.selectedCurrentId == this.latestQuestionnaire['id'] || this.selectedCurrentId == this.latestQuestionnaire['di_questionnaire']['id']) &&
                    this.latestQuestionnaire['step'] >= 3 && !this.latestQuestionnaire['di_questionnaire']['archived']
                ) {
                    this.canEdit = true;
                }
                this.isLoading = false;
                this.loadMapCompleted.next(true);
                this.interactiveSymptomMap = document.getElementById('symptom-map-svg-content-' + this.symptomMapId);
                return this.getGraphics();
            });
    }

    isTouchDevice() {
        return ('ontouchstart' in document.documentElement || navigator.maxTouchPoints > 0 || navigator.maxTouchPoints > 0);
    }

    updateSelectedDiagnoses(response: any) {
        if (this.questionnairesComponent && response.selected_diagnoses) {
            // Compare response data if have any changes
            if(!_.isEqual(_.map(this.patientService.selectedDiagnoses, 'id'), _.map(response.selected_diagnoses, 'id'))){
                this.patientService.selectedDiagnoses = response.selected_diagnoses;
                this.appService.publish('patient', {selectedDiagnosesAreUpdated: true});
            }

        }
        if (this.questionnairesComponent && response.proposal) {
            if(!_.isEqual(_.map(this.patientService.proposalData, 'id'), _.map(response.proposal, 'id'))){
                this.patientService.proposalData = response.proposal;
                this.appService.publish('updateDiagnosis', { items: response.proposal });
            }
        }
    }

    zoom(svgPanZoomInstance = this.svgPanZoomInstance) {
        const currentHeight = this.symptomMapSvg.nativeElement.offsetHeight;

        if (currentHeight == 0) {
            return
        }

        if (this.isFullScreen) {
            svgPanZoomInstance.zoom((this.zoomLevel * (this.minimizedHeight / currentHeight) + 0.5));
        } else {
            svgPanZoomInstance.zoom(this.zoomLevel);
        }
    }

    zoomIn(svgPanZoomInstance: any) {
        if (this.zoomLevel !== 3) {
            this.zoomLevel++;

            // disable the page scrolling when panning the map
            const map = document.querySelector('#symptom-map-svg-content-' + this.symptomMapId + ' svg') as HTMLElement;
            map.style.touchAction = 'none';

            this.zoom(svgPanZoomInstance);

            this.panValues = svgPanZoomInstance.getPan();

            document.querySelector('#symptom-map-svg-content-' + this.symptomMapId + ' svg')
                .setAttribute('class', 'level' + this.zoomLevel);
        }
    }

    zoomOut(svgPanZoomInstance: any) {
        if (this.zoomLevel > 1) {
            this.zoomLevel--;

            this.zoom(svgPanZoomInstance);

            this.panValues = svgPanZoomInstance.getPan();

            document.querySelector('#symptom-map-svg-content-' + this.symptomMapId + ' svg')
                .setAttribute('class', 'level' + this.zoomLevel);

            if (this.zoomLevel === 1) {
                return this.resetOverviewMap();
            }
        }
    }

    resetOverviewMap(){
        if(this.zoomLevel > 1){
            this.zoomLevel = 1;
            this.zoom(this.svgPanZoomInstance);
        }
        this.svgPanZoomInstance.resize();
        this.adjustFirstZoomScale();
        this.svgPanZoomInstance.center();

        // enable the page scrolling
        const map = document.querySelector('#symptom-map-svg-content-' + this.symptomMapId + ' svg') as HTMLElement;
        map.setAttribute('class', 'level' + this.zoomLevel);
        map.style.touchAction = 'pan-y';
    }

    exportSimplifiedPDF() {
        this.exportPDF(true);
    }

    initMapPositionExport() {
        // clone svg map
        const mapData = document.getElementById('map-content-' + this.symptomMapId);
        if (mapData) {
            mapData.innerHTML = document.getElementById('symptom-map-svg-content-' + this.symptomMapId).innerHTML;
            const svgNode = mapData.firstElementChild;
            let gNode = svgNode.firstElementChild;
            svgNode.setAttribute('class', 'level2');
            gNode.setAttribute('id', 'svg-pan-zoom_viewport');
            gNode.setAttribute('transform', 'matrix(0.48654 0 0 0.48654 -87 -138)');
            gNode.setAttribute('style', 'transform: matrix(0.671519, 0, 0, 0.671519, -93, -192);');
        }
    }

    exportPDF(isSimplifiedVersion: boolean = false) {
        if (this.zoomLevel === 1) {
            this.svgPanZoomInstance.center();
        }

        setTimeout(() => {
            this.exportSymptomMap(isSimplifiedVersion);
        }, 200);
    }

    exportPDFA4() {
        setTimeout(() => {
            this.exportSymptomMap(false, false, false);
        }, 200);
    }

    exportPNGA4() {
        setTimeout(() => {
            this.exportSymptomMap(false, true, false);
        }, 200);
    }

    exportSimplifiedPNG() {
        this.exportPNG(true);
    }

    exportPNG(isSimplifiedVersion: boolean = false) {
        if (this.zoomLevel === 1) {
            this.svgPanZoomInstance.center();
        }

        setTimeout(() => {
            this.exportSymptomMap(isSimplifiedVersion, true);
        }, 200);
    }

    exportSymptomMap(isSimplifiedVersion: boolean = false, isPNG: boolean = false, isA3: boolean = true) {
        if (!this.initialSymptomMap) {
            return false;
        }

        this.initMapPositionExport();

        const form = <HTMLFormElement>document.getElementById('frmExport');
        const frmAttributes = <HTMLFormElement>document.getElementById('frm-DI-attributes');

        this.exportRoute.current = this.exportRoute.current ? this.exportRoute.current : form.action;

        const showUnselectedDomain = this.allDomainsAreShown ? '' : 'hidden-unselected-domains';
        const pageSize = isA3 ? 'page-a3' : 'page-a4';
        const comparisonCls = this.selectedComparisonType ? 'comparison focus-mode ' + this.selectedComparisonType : '';
        const mapContents = '<div id="symptom-map-svg-content-' + this.symptomMapId + '" class="symptom-map ' + showUnselectedDomain + ' ' + pageSize + ' ' + comparisonCls + '">'
            + document.querySelector('#map-content-' + this.symptomMapId).innerHTML + '</div>';
        document.getElementById('symptom-content').innerHTML = mapContents;

        const legendContents = '<div class="legends">' + document.querySelector('.legends').innerHTML + '</div>';
        document.getElementById('symptom-legends').innerHTML = legendContents;
        document.getElementById('clinic-info').innerHTML = localStorage.getItem('profile-avatar');

        // Remove all diagnosis info
        frmAttributes.innerHTML = '';
        const diAttributes = document.querySelectorAll('.diagnosis-attribute .item b');

        for (let i = 0; i < diAttributes.length; i++) {
            const att = document.createElement('input');
            att.name = 'attributes[]';
            att.value = diAttributes[i].innerHTML;
            att.className = 'frm-diagnosis-attribute';
            frmAttributes.appendChild(att);
        }

        if (this.selectedCurrentId !== 0) {
            const rDate = document.createElement('input');
            rDate.value = this.currentDates[this.findDateIndex(this.selectedCurrentId, this.currentDates)].date;
            rDate.className = 'reply-date';
            rDate.name = 'replyDate';
            form.appendChild(rDate);
        }

        const cDate = document.createElement('input');
        cDate.className = 'comparison-date';
        cDate.name = 'comparisonDate';
        cDate.value = '0';
        const compareData = this.findCurrentComparedDate(this.selectedComparisonId, this.completedDates);
        if (this.selectedComparisonId !== 0) {
            cDate.value = compareData['date'];
        }
        form.appendChild(cDate);

        if (form.action.indexOf('?token') === -1) {
            this.token = this.authService.user['token'];
            form.action = form.action + '?token=' + this.token;
        }
        form.action += '&map-type=' + this.symptomMapId;
        if (compareData.type !== '') {
            form.action += '&compare-map-type=' + compareData['type'];
        }
        form.action += '&patient-questionnaire-id=' + this.selectedCurrentId;

        // Check is full screen or not
        form.action += '&fullscreen=' + this.isFullScreen;
        let width, height;
        if (isA3) {
            form.action += '&page-size=a3';
            width = 2338;
            height = 1653;
        } else {
            form.action += '&page-size=a4';
            width = 1450;
            height = 990;
        }
        form.action += '&height=' + height;
        form.action += '&width=' + width;

        if (isSimplifiedVersion) {
            form.action += '&noBackground=1';
        } else {

            form.action += '&noBackground=0';
        }

        if (isPNG) {
            form.action += '&isPNG=1';
        } else {
            form.action += '&isPNG=0';
        }

        //Language
        form.action += '&lang=' + this.translate.currentLang;

        this.openConfirmModal({
            icon: 'fas fa-info-circle'
        });

        form.submit();

        form.action = this.exportRoute.current;
    }

    loadLatestSymptomMap(currentId) {
        if (document.querySelector('#map-content-' + this.symptomMapId + ' svg') == null) {
            return;
        }

        this.SVG = d3.select('#map-content-' + this.symptomMapId + ' svg');
        const form = <HTMLFormElement>document.getElementById('frmExportLatest');
        const frmAttributes = <HTMLFormElement>document.getElementById('frm-DI-attributes-latest');

        if (this.patientService.latestMapId < currentId || this.mapUpdated) {
            this.patientService.latestMapId = currentId;
        }

        this.initMapPositionExport();

        const showUnselectedDomain = '';
        const pageSize = 'page-a3';
        const mapContents = '<div id="symptom-map-svg-content-' + this.symptomMapId + '" class="symptom-map ' + showUnselectedDomain + ' ' + pageSize + '">'
            + document.querySelector('#map-content-' + this.symptomMapId).innerHTML + '</div>';
        document.getElementById('symptom-content-latest').innerHTML = mapContents;

        const legendContents = '<div class="legends">' + document.querySelector('.legends').innerHTML + '</div>';
        document.getElementById('symptom-legends-latest').innerHTML = legendContents;

        document.getElementById('clinic-info-latest').innerHTML = localStorage.getItem('profile-avatar');

        // Remove all diagnosis info
        frmAttributes.innerHTML = '';
        const diAttributes = document.querySelectorAll('.diagnosis-attribute .item b');

        for (let i = 0; i < diAttributes.length; i++) {
            const att = document.createElement('input');
            att.value = diAttributes[i].innerHTML;
            att.name = 'attributes[]';
            att.className = 'frm-diagnosis-attribute';
            frmAttributes.appendChild(att);
        }

        if (this.patientService.latestMapId !== 0) {
            const rDate = document.createElement('input');
            rDate.value = this.currentDates[this.findDateIndex(this.patientService.latestMapId, this.currentDates)] ? this.currentDates[this.findDateIndex(this.patientService.latestMapId, this.currentDates)].date : '';
            rDate.name = 'replyDate';
            rDate.className = 'reply-date';
            form.appendChild(rDate);
        }

        if (form.action.indexOf('?token') === -1) {
            this.token = this.authService.user['token'];
            form.action = form.action + '?token=' + this.token;
        }
        form.action += '&map-type=' + this.symptomMapId;
        form.action += '&patient-questionnaire-id=' + this.patientService.latestMapId;

        // Check is full screen or not
        form.action += '&fullscreen=false';
        let width = 2338;
        let height = 1653;
        form.action += '&page-size=a3';
        form.action += '&height=' + height;
        form.action += '&width=' + width;
        form.action += '&noBackground=0';

        form.action += '&isPNG=0';

        //Language
        form.action += '&lang=' + this.translate.currentLang;
    }

    exportLatestMap(currentId) {
        const form = <HTMLFormElement>document.getElementById('frmExportLatest');
        form.submit();
    }

    openConfirmModal(params: Object) {
        // const dialog = this.dialog.openAlert(params);
        // dialog.onSubmit(() => {
        //     return;
        // });
        //
        // if (this.isFullScreen) {
        //     let element = document.querySelector('app-alert > div') as HTMLElement;
        //     element.style.zIndex = "10000";
        // }
        //
        // dialog.showAlert('The map is being exported. Please wait a few seconds.');
        //
        // setTimeout(() => {
        //     dialog.hideModal();
        // }, 2000);
        this.isLoading = true;
        let _self = this;
        setTimeout(() => {
            _self.isLoading = false;
        }, 2000);
    }

    findDateIndex(id: number, array: Array<Object>) {
        if (typeof (id) !== 'number') {
            id = +id;
        }

        for (const item in array) {
            if (array[item]['id'] === id) {
                return item;
            }
        }
        return -1;
    }

    findCurrentComparedDate(id: number, array: Array<Object>) {
        if (typeof (id) !== 'number') {
            id = +id;
        }

        for (const item in array) {
            if (array[item]['sr_id'] === id) {
                return  {
                    date : array[item]['sr_completed_date'],
                    type : "SE"
                }
            } else if (array[item]['di_id'] === id) {
                return {
                    date : array[item]['di_completed_date'],
                    type : "DI"
                }
            }
        }
        return {
            date : "",
            type : ""
        };
    }

    centerSymptomMap(svgPanZoomInstance: any) {
        svgPanZoomInstance.center();
    }

    openPopover($event) {
        $event.stopPropagation();
        this.popover.pop.show();
    }

    openProposal($event){
        this.isLoading = true;
        this.viewMode = false;
        this.editMode = false;
        this.openInteractive = false;
        this.closeInteractive(true);
        const _self = this;
        setTimeout(function () {
            _self.toggleFullScreen(true);
            _self.openProposalDiagnosis = true;
            _self.isLoading = false;
        }, 800);
    }

    closeComparesDateDropdown($event) {
        if (this.comparesDateDropdown.isOpen == false) {
            $event.stopPropagation();
        }
    }

    getPosition() {
        if (!document.getElementById('symptom-map-menu-btn-' + this.selectedSymptomMap)) {
            return false;
        }

        let pos = document.getElementById('symptom-map-menu-btn-' + this.selectedSymptomMap).getBoundingClientRect();
        let menuContent = document.getElementById('symptom-map-menu-content-' + this.selectedSymptomMap).getBoundingClientRect();
        this.menuBtn.top = pos.top + 'px';
        this.menuBtn.right = pos.right + 'px';
        let bottomSpacing = window.innerHeight - pos.top - pos.height;

        if (bottomSpacing > menuContent.height) {
            this.dropdownPosition.top = pos.height - 2 + 'px';
            this.dropdownPosition.right = '0px';
            this.dropdownPosition.position = 'absolute';
            this.menuDirection = 'toggle-down';
        }
        else {
            this.dropdownPosition.right = 'calc(100% - ' + this.menuBtn.right + ')';
            this.dropdownPosition.position = 'fixed';
            this.dropdownPosition.top = (pos.top + 2 - menuContent.height) + 'px';
            this.menuDirection = 'toggle-up';
        }
    }

    showMenuDropdown() {
        this.showDropdown = !this.showDropdown;

        //Fix issue button create SE is hide

    }

    @HostListener('window:scroll', ['$event'])
    onWindowScroll($event) {
        this.getPosition();
    }

    onMouseWheel($event) {
        if (!this.isScrolling) {
            this.isScrolling = true;
            if ($event.deltaY < 0) {
                this.zoomIn(this.svgPanZoomInstance)
            }
            else if ($event.deltaY > 0) {
                this.zoomOut(this.svgPanZoomInstance);
            }

            setTimeout(() => {
                this.isScrolling = false;
            }, 500);
        }

        $event.preventDefault();
    }

    // Function to return list of numbers from 0 to n-1
    numSequence(n: number): Array<number> {
        n = n < 0 ? 0 : n;
        return Array(n);
    }

    getGraphics() {
        if (!this.selectedCurrentId || !this.selectedComparisonId) {
            return false;
        }
        this.patientService.getGraphicComparision(this.selectedCurrentId, this.selectedComparisonId).subscribe((res) => {
            this.graphicData = res['data'];
        });
    }

    exportGraphics() {
        const form = <HTMLFormElement>document.getElementById('graphicExport');
        if (this.selectedCurrentId !== 0) {
            const rDate = document.createElement('input');
            rDate.value = this.currentDates[this.findDateIndex(this.selectedCurrentId, this.currentDates)].date;
            rDate.name = 'replyDate';
            rDate.className = 'reply-date';
            form.appendChild(rDate);
        }

        const cDate = document.createElement('input');
        cDate.name = 'comparisonDate';
        cDate.className = 'comparison-date';
        cDate.value = '0';

        let token = this.authService.user['token'];
        form.action += '?token=' + token;
        form.action += '&current-id=' + this.selectedCurrentId;
        form.action += '&compare-id=' + this.selectedComparisonId;
        form.action += '&lang=' + this.translate.currentLang;
        form.action += '&patientId=' + this.patientId;
        form.action += '&origin-type=' + this.symptomMapId;

        const compareData = this.findCurrentComparedDate(this.selectedComparisonId, this.completedDates)
        if (this.selectedComparisonId !== 0) {
            cDate.value = compareData['date'];
            form.appendChild(cDate);
            form.action += '&compare-map-type=' + compareData['type'];
        }

        form.submit();
    }

    callExport() {
        this.expertDatas = this.interactiveMapComponent.mapData.domain;

        if ((this.selectedCurrentId == this.latestQuestionnaire['id'] || this.selectedCurrentId == this.latestQuestionnaire['di_questionnaire']['id']) &&
        (!this.latestQuestionnaire['archived'])
        ) {
            // Incase SR is not finish, call api to clone data
            this.questionnairesService.openQuestionnaireEditMode(this.latestQuestionnaire['di_questionnaire']['id'], 'di', 1).subscribe(res => {
                this.expertDatas = res['result'];
                return this.calculateExpertItem();
            });
        }

        return this.calculateExpertItem();
    }

    calculateExpertItem() {
        //Wait until UI render complete
        this.showExpertsElement = true;
        setTimeout(() => {
            let height = 0;
            let splitItems = [];
            const domains = document.querySelectorAll('#map-content-expert-item .item');
            domains.forEach((domain, domainIndex) => {
                let domainName = domain.querySelector('.domain');
                if (domainName) {
                    height+=domainName.clientHeight;
                }
                let symptoms = domain.querySelectorAll('.symptom');
                symptoms.forEach((symptom, symptomIndex) => {
                    height+=symptom.clientHeight;
                    if (height > 1240) {

                        if (symptoms[symptomIndex - 1]) {
                            splitItems.push(symptoms[symptomIndex - 1].getAttribute('id'));
                            height = symptom.clientHeight;
                        } else {
                            let lastSymptomOfDomain = domains[domainIndex - 1].querySelector('.symptom:last-child');
                            if (lastSymptomOfDomain) {
                                splitItems.push(lastSymptomOfDomain.getAttribute('id'));
                                height = symptom.clientHeight + domains[domainIndex - 1].querySelector('.domain').clientHeight;
                            }
                        }
                    }
                });
            });

            const form = <HTMLFormElement>document.getElementById('expertExport');
            let token = this.authService.user['token'];
            form.action += '?token=' + token;
            form.action += '&patient-id=' + this.patientId;
            form.action += '&patient-questionnaire-id=' + this.selectedCurrentId;
            form.action += '&lang=' + this.translate.currentLang;
            form.action += '&split-items=' + splitItems.toString();

            this.openConfirmModal({
                icon: 'fas fa-info-circle'
            });
            form.submit();
            this.showExpertsElement = false;
        }, 1000);
    }

    enableEdit(type) {
        this.enableEditMode.emit({questionnaire: this.latestQuestionnaire, type: type});
    }

    openEditMode() {
        this.editMode = !this.editMode;
        this.viewMode = !this.viewMode;
        this.openInteractive = true;
        this.openProposalDiagnosis = false;
        this.toggleFullScreen(this.editMode);
    }

    openInteractiveMap() {
        this.editMode = true;
        this.viewMode = false;
        this.isFullScreen = false;
        this.openInteractive = true;
        this.openProposalDiagnosis = false;
    }

    openProposalMap() {
        this.editMode = true;
        this.viewMode = false;
        this.isFullScreen = false;
        this.openInteractive = false;
        this.openProposalDiagnosis = true;
        if (this.patientService.activeTab !== this.patientService.PATIENTTABS.PROPOSALS) {
            this.changePatientTab.emit(this.patientService.PATIENTTABS.PROPOSALS);
        }
        // save statistics for current user
        this.usersService.saveStatistics(this.reviewProposalStatisticKey)
            .subscribe(data => {
            });
    }

    openCompareMode() {
        this.closeInteractive(true);
        this.openComparison = !this.openComparison;
        this.viewMode = true;
        this.editMode = false;

        if (this.openComparison) {
            this.selectedComparisonType = 'none';
            // Need timeout to render component before call api
            setTimeout(() => {
                if (this.comparisonDates.length > 0) {
                    return this.comparisonMap.selectDate(this.comparisonDates[0]['id'], this.comparisonDates[0]['date'], this.symptomMapId);
                }

                if (this.symptomMapId === 'SE') {
                    return this.comparisonMap.selectDate(this.completedDates[0]['di_id'], this.completedDates[0]['di_completed_date'], 'DI');
                }
                this.comparisonMap.selectDate(this.completedDates[0]['sr_id'], this.completedDates[0]['sr_completed_date'], 'SE');
            }, 200);
        } else {
            this.selectedComparisonType = null;
            this.viewMode = this.symptomMapId === 'SE' ? true : false;
            this.editMode = !this.viewMode;
            this.openInteractive = !this.viewMode;
            this.drawComparisonMap(0);
        }
    }

    onDateSelect(date) {
        this.selectedCurrentId = date.id;
        if (this.openComparison) {
            this.viewMode = this.symptomMapId === 'SE' ? true : false;
            this.editMode = !this.viewMode;
            this.openInteractive = !this.viewMode;
            this.openComparison = false;
        }
        this.onSelect();
    }

    drawComparisonMap(id) {
        this.selectedComparisonId = id;
        this.loadSymptomMap();
    }

    applyComparison(status) {
        let comparisonType = '';
        for (const [key, value] of Object.entries(status)) {
            if (value) {
                comparisonType = comparisonType + ' ' + key;
            }
        }
        this.selectedComparisonType = comparisonType;

        // Check all filter are false
        if(Object.entries(status).every(item => !item[1])) {
            this.selectedComparisonType = 'none';
        }
    }

    highlightProposalDiagnosis(params) {
        if (!params) {
            return this.unhighlightProposalDiagnosis();
        }
        const symptomIds = params.id;
        const symptomMap = document.getElementById('symptom-map-svg-content-' + this.symptomMapId);
        symptomIds.forEach(id => {
            let node = symptomMap.querySelector('[attr-systemid="' + id + '"]');
            if (!node) {
                return;
            }

            if (params.selected) {
                node.parentElement.classList.add(params.class);
            } else {
                node.parentElement.classList.remove(params.class);
            }
        });
    }

    unhighlightProposalDiagnosis() {
        // Remove all highlight
        document.querySelectorAll('.symptom-icon.fullfilled-highlight').forEach(item => {
            item.classList.remove('fullfilled-highlight');
        });
        document.querySelectorAll('.symptom-icon.not_fullfilled-highlight').forEach(item => {
            item.classList.remove('not_fullfilled-highlight');
        });
    }

    openAlertModal(event) {
        const dialog = this.dialog.openAlert(event.params);
        dialog.onSubmit(() => {
            return;
        });

        dialog.showAlert(event.errorMessage);
    }

}
